module.exports = __webpack_public_path__ + "static/media/az.451284ce.svg";